import { isNonEmptyString } from "@cayuse/shared-react.utils.type-checks";

import {
	AWARDS_SUMMARY_ITEMS,
	IS_DEV,
} from "globals/constants";
import store, { dispatch } from "store/store";
import {
	parseJSON,
	getKeysFromColumnHeaders,
	findAwards as queryAwards,
	notifyError,
} from "utils";
import { countNumberSummaryItems } from "utils/summary";
import { awards as constants } from "store/constants";
import { actionFactory as feedActionFactory } from "store/factories/feed";
import { actionLoaderFactory } from 'store/factories/fetchable';
import { updateAwardAdminTeamMembers } from "store/actions/award";
import Pager from "components/Pager";
import { api } from "services";
import { awardListSelectors, columnsSelectors } from "../selectors";
import { mutateAdminTeamMembers } from "utils/teamMembers";
import { cloneDeep } from "lodash";


export const { setPaging } = feedActionFactory(constants);

const listFactory = actionLoaderFactory(constants, constants.AWARD_LIST);
const summaryFactory = actionLoaderFactory(constants, constants.AWARD_LIST_SUMMARY);

export const setAwardList = listFactory.setData;

export const findAwards = async ({ pageLimit, pageOffset, searchTerms, fieldKeys, isRefresh = false }) => {
	return listFactory.createLoaderAction(
    () => queryAwards({ pageLimit, pageOffset, searchTerms, fieldKeys }),
    [
      (response) => {
				listFactory.setData(response);

				return response;
			},
			(error) => {
				const message = isNonEmptyString(error) ? error : error.message || "Something went wrong";

				notifyError(message, error);
				listFactory.setError(message);
			},
		],
		{ isRefresh },
	);
};

export const getAwardsSummary = async () => {
	return summaryFactory.createLoaderAction(
		api.awards.getSummary,
		[
			(response) => {
				summaryFactory.setData(countNumberSummaryItems(AWARDS_SUMMARY_ITEMS, response));
			},
			(error) => {
				// const message = IS_DEV ? error.message : getState().dictionary.projects.errors.tilesFailedLoad;
				const message = IS_DEV ? error.message : "An error has occurred";

				notifyError(message, error);
				summaryFactory.setError(message);
			},
		],
	);
};

export const setAwardSearchBar = search => {
	dispatch({ type: constants.SET_SEARCH, search: isNonEmptyString(search) ? parseJSON(search) : search });
};

export const refreshAwards = async () => {
	const state = store.getState();
	const {
		search: searchTerms,
		paging: {
			pageNumber,
			pageLimit,
		},
	} = awardListSelectors.content(state);
	const { activeColumns } = columnsSelectors.awards(state);

	const pageOffset = Pager.pageOffsetByPageNumber(pageNumber);
	const fieldKeys = getKeysFromColumnHeaders(activeColumns);

	getAwardsSummary();
	findAwards({ pageLimit, pageOffset, searchTerms, fieldKeys, isRefresh: true });
};

export const updateAdminTeamMembersPerAward = idAdminTeamMemberArray => {
	const items = cloneDeep(awardListSelectors.content().items);

	mutateAdminTeamMembers(idAdminTeamMemberArray, items);

	listFactory.setData({ items });

	updateAwardAdminTeamMembers(idAdminTeamMemberArray);
};
